import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_NOTICE } from '@/api/endpoints';
import { NOTICE_QUERY_KEY } from '@/api/queryKeys';
import type { Notice } from '@/types/user';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useDashboardNotice = () =>
  useQuery<Notice | null>({
    queryKey: NOTICE_QUERY_KEY,
    queryFn: () =>
      apiClient.get<Notice | null>(API_NOTICE).then(unwrapAxiosResponse),
  });
